import { StateType } from './types';

export default (): StateType => ({
  header: {
    right_action: undefined,
  },
});
